import Swal from 'sweetalert2';

const AlertAndConfirmation = ({
  title = locales('errors.title'),
  text = '',
  type = 'success',
  timer = 3000
}) => {
  return Swal.fire({
    title: title,
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer,
    text: text,
    icon: type
  });
};

export default AlertAndConfirmation;
